import compact from 'lodash/compact';
import { SelfServiceAPI } from 'types';
import { PaymentSummaryProps } from '../PaymentSummary';

export type Payments = ReturnType<typeof flattenTransactions>;

const flattenTransactions = ({ transactions }: SelfServiceAPI.Booking) => {
  return transactions.flatMap((transaction) => {
    const { chargeBreakdown, createdAt, type, reason } = transaction;
    const { points, creditCard, creditNote, qantasGroupCreditVoucher } = chargeBreakdown;
    const transactionDetails = { createdAt, type, reason };

    return compact([
      points.paymentMethod && {
        method: 'points',
        ...points.paymentMethod,
        ...transactionDetails,
        total: { amount: points.total, currency: SelfServiceAPI.Currency.PTS },
      },
      creditCard.paymentMethod && {
        method: 'credit_card',
        ...creditCard.paymentMethod,
        ...transactionDetails,
        total: { amount: creditCard.total, currency: SelfServiceAPI.Currency.AUD },
      },
      creditNote.paymentMethod && {
        method: 'credit_note',
        ...creditNote.paymentMethod,
        ...transactionDetails,
        total: { amount: creditNote.total, currency: SelfServiceAPI.Currency.AUD },
      },
      qantasGroupCreditVoucher.paymentMethod && {
        method: 'qantas_group_credit_voucher',
        ...qantasGroupCreditVoucher.paymentMethod,
        ...transactionDetails,
        total: { amount: qantasGroupCreditVoucher.total, currency: SelfServiceAPI.Currency.AUD },
      },
    ]);
  });
};

export const bookingToPaymentSummaryProps = (booking: SelfServiceAPI.Booking): PaymentSummaryProps => {
  const { paidBeforeCancellation } = booking;
  const transactionAmounts: Payments = flattenTransactions(booking);
  const paidToDateAmounts = paidBeforeCancellation.totals;

  return { transactionAmounts, paidToDateAmounts };
};
